import { makeAutoObservable } from 'mobx'
import getInstance from 'apis/index'
import Xhr from 'xmov-lib/utils/xhr'

class AppStore {
  rootStore: IRootStore | null = null
  user: IUser | null = null
  nav: INav = {
    defaultSelectedKeys: ['1'],
    defaultOpenKeys: ['1'],
  }
  xhr!: Xhr
  pathName!: string

  constructor(rootStore: IRootStore) {
    this.rootStore = rootStore
    makeAutoObservable(this)
  }

  setXhr() {
    this.xhr = getInstance()
  }

  setNav(nav: INav) {
    // console.log('nav: ', nav);
    this.nav = nav
  }

  setPathName(name:string){
    this.pathName = name
  }

  setUser(user: IUser) {
    // console.log('user: ', user);
    this.user = user
  }
}

export default AppStore